<template>
	<v-layout row v-if="!dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<agency-choose-funding
				:agency-id="agencyId"
				:readonly="true"
				:value="old"
			/>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<agency-choose-funding
				:agency-id="agencyId"
				:readonly="true"
				:value="current"
			/>
		</v-flex>
	</v-layout>
</template>
<script>
	import NewVersionMarker from "../../offer/compareComponents/NewVersionMarker";
	import OldVersionMarker from "../../offer/compareComponents/oldVersionMarker";
	import AgencyChooseFunding from "../components/AgencyChooseFunding";

	export default {
		name: 'AgencyCompareProjectFunding',
		components: {AgencyChooseFunding, NewVersionMarker, OldVersionMarker},

		computed: {
			dataSame() {
				let comparisonResult = this.current === this.old;
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			current: {},
			old: {},
			contestId: {},
			agencyId: {}
		}
	};
</script>
